/*
    file to load language for the app
*/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { resources } from './app/employer/config/Locale';

i18n
   .use(initReactI18next)
   .init({
      resources,
      lng: 'en',
      fallbackLng: 'en',
      keySeparator: true,
      interpolation: {
         escapeValue: false,
      },
      react: {
         wait: false,
         nsMode: 'default',
      },
   }, (err) => {
      console.error(err);
   });

export default i18n;
